import { ComprehensiveAnalysis } from './ComprehensiveAnalysis';
export default ComprehensiveAnalysis;
